// Mock content for the Steno | PACE MASTER clone (frontend-only)

export const brand = {
  name: 'Steno',
  sub: 'PACE MASTER',
  tagline: 'REAL-TIME COURTROOM PACER',
  version: 'v1.2.0',
};

export const hero = {
  titleLine1: 'Courtroom Cadence Monitoring,',
  titleAccent: 'Perfected.',
  description:
    'Steno | PACE MASTER provides courtroom legal stenographers and public speakers with continuous, visual, real-time cadence diagnostics to protect verbatim accuracy.',
  privacy:
    'This tool is a real-time visual pace indicator only. No audio, speech, or session data is ever recorded, transmitted, or stored. All processing occurs entirely within your browser.',
};

export const features = [
  {
    title: 'Live WPM Circle',
    desc: 'A beautiful visual speedometer showing speech cadence in real-time.',
  },
  {
    title: 'Subdued Audio Waves',
    desc: 'Elegant, whisper-quiet visual diagnostics that capture micro-level speech.',
  },
  {
    title: 'Responsive Windows',
    desc: 'Configurable averages from 3 to 15 seconds to smooth speed calculations.',
  },
  {
    title: 'Trial 1-Minute Preview',
    desc: 'Test-drive the real-time speedometer completely free for 1 minute.',
  },
];

export const pricingPlans = [
  {
    id: 'monthly',
    name: 'Monthly Pass',
    price: '$10',
    unit: '/ month',
    sub: null,
    badge: null,
    highlight: false,
    cta: 'Subscribe Monthly',
    ctaStyle: 'outline',
    checkoutUrl: 'https://buy.stripe.com/eVq8wH5bB1oZ6Hc1QW9sk00',
    perks: [
      'Infinite visual speech-pacing tracking',
      'Advanced metrics (spurt zones, peaks, logs)',
      'Customizable responsiveness (3s - 15s)',
      'Secure, 100% offline-ready local cache',
      'Zero audio logging (Total Confidentiality)',
      'Cancel anytime easily',
    ],
  },
  {
    id: 'annual',
    name: 'Annual Pass',
    price: '$100',
    unit: '/ year',
    sub: 'Equivalent to just $8.33 / month!',
    badge: '\u2605 BEST VALUE (SAVE 16%)',
    highlight: true,
    cta: 'Subscribe Annually',
    ctaStyle: 'solid',
    checkoutUrl: 'https://buy.stripe.com/6oU6ozbzZ7Nn8PkfHM9sk01',
    perks: [
      'Infinite visual speech-pacing tracking',
      'Advanced metrics (spurt zones, peaks, logs)',
      'Customizable responsiveness (3s - 15s)',
      'Secure, 100% offline-ready local cache',
      'Zero audio logging (Total Confidentiality)',
      'Priority developer feedback line',
      'Includes all future ecosystem features',
    ],
  },
  {
    id: 'lifetime',
    name: 'Lifetime Pass',
    price: '$250',
    unit: 'one-time',
    sub: 'Never pay again. Own it for life.',
    badge: 'LIFETIME ACCESS',
    highlight: false,
    cta: 'Purchase Lifetime',
    ctaStyle: 'outline-gold',
    checkoutUrl: 'https://buy.stripe.com/aFa00b9rR9Vv9To8fk9sk02',
    perks: [
      'Infinite visual speech-pacing tracking',
      'Advanced metrics (spurt zones, peaks, logs)',
      'Customizable responsiveness (3s - 15s)',
      'Secure, 100% offline-ready local cache',
      'Zero audio logging (Total Confidentiality)',
      'Never pay again (Lifetime access)',
      'Includes all future ecosystem features',
      'Priority developer feedback line',
    ],
  },
];

export const footer = {
  ecosystem: 'DraftMaster.AI Ecosystem',
  copyright: '\u00A9 2026 DraftMaster.AI LLC. All rights reserved.',
  note: 'Confidential Stenographer Support Tool',
  links: ['Disclaimer', 'Support'],
};
